import React from 'react';
import {connect} from 'react-redux';
import NavbarEntitySearch from '../components/NavbarEntitySearch';
import {openMobileNav, closeMobileNav} from '../reducers/mobileNav';

class MobileSearch extends React.Component {
    render() {
        return (
            <div>
                <NavbarEntitySearch autoFocus={true} isMobile={true} />
            </div>
        );
    }
}

@connect(
    state => ({mobileNavIsOpen: state.mobileNav.isOpen && state.mobileNav.type == 'search'}),
    {openMobileNav, closeMobileNav}
)
export default class MobileNavbarSearch extends React.Component {
    toggleOpen(e) {
        e.preventDefault();
        if(!this.props.mobileNavIsOpen) {
            this.props.openMobileNav('search', <MobileSearch />);
        } else {
            this.props.closeMobileNav();
        }
    }
    render() {
        var liClassName = this.props.mobileNavIsOpen ? "dropdown open" : '';
        return (
            <li className={liClassName}>
                <a className="dropdown-toggle" href="#" onClick={this.toggleOpen.bind(this)} data-toggle="dropdown">
                    <i className="fa fa-search"></i>
                </a>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/MobileNavbarSearch.js